import { cloneDeep } from '@apollo/client/utilities';
import { toFilterString } from '../../util/string.util';
import { UnitSystem } from '../uom';

export const SystemUser = {
  id: '00000000-0000-0000-0000-000000000001',
  email: 'system@ventory.io',
};

export class User {
  id!: string;
  email!: string;
  userId!: string;
  firstName!: string;
  lastName!: string;
  version!: number;
  createdAt!: Date;
  updatedAt!: Date;
  createdBy!: string;
  updatedBy!: string;
  acceptedAgreements?: Date;
  acceptedPrivacyPolicy?: Date;
  acceptedTerms?: Date;
  isOnboarded?: boolean;
  language?: string;
  locale?: string;
  notificationsToken?: string;
  unitSetting?: UnitSystem;
  profilePicture?: string;
  supportHMAC?: string;
  verified!: boolean;

  constructor(obj: any) {
    Object.assign(this, cloneDeep(obj));
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  filter(filterString: string): boolean {
    return (
      toFilterString(this.email).includes(filterString) ||
      toFilterString(this.firstName).includes(filterString) ||
      toFilterString(this.lastName).includes(filterString) ||
      toFilterString(`${this.firstName} ${this.lastName}`).includes(filterString)
    );
  }

  static locale(user?: User | null): string {
    if (!user) return 'en-GB';
    if (user.locale) return user.locale;

    try {
      return Intl.NumberFormat().resolvedOptions().locale;
    } catch (e) {
      return (window.navigator as any)['userLanguage'] || window.navigator.language;
    }
  }
}

export enum UserUnitPreference {
  metric = 'METRIC',
  imperial = 'IMPERIAL',
}

export enum UserLanguagePreference {
  english = 'ENGLISH',
  dutch = 'DUTCH',
}
